const randNum = Number.parseInt(Math.random() * 100000, 10);

function randomPracticeName() {
  const validChars = 'abcdefghijklmnopqrstuvwxyz';
  let text = 'Practice ';
    for (var i = 0; i < 8; i++) {
        text += validChars.charAt(Math.floor(Math.random() * validChars.length));
    }
  return text;
}

function randomEmail() {
  const validCharsGroup1 = 'abcdefghijklmnopqrstuvwxyz';
  const validCharsGroup2 = '_.';
  const validCharsGroup3 = validCharsGroup1 + '0123456789';
  let i, text = '';
  for (i = 0; i < 6; i++) {
    text += validCharsGroup1.charAt(Math.floor(Math.random() * validCharsGroup1.length));
  }
  text += validCharsGroup2.charAt((randNum % 2) - 1);
  for (i = 0; i < 6; i++) {
    text += validCharsGroup3.charAt(Math.floor(Math.random() * validCharsGroup3.length));
  }
  return text + '@tlcqa.com';
}

function randomPracticePhone() {
  const validChars = '0123456789';
  let i, text = '(';
  for (i = 0; i < 3; i++) {
    text += validChars.charAt(Math.floor(Math.random() * validChars.length));
  }
  text += ') ';
  for (i = 0; i < 3; i++) {
    text += validChars.charAt(Math.floor(Math.random() * validChars.length));
  }
  text += '-';
  for (i = 0; i < 4; i++) {
    text += validChars.charAt(Math.floor(Math.random() * validChars.length));
  }
  return text;
}

function randomPersonName(role, nameType) {
  const validChars = 'abcdefghijklmnopqrstuvwxyz';
  let text = role + '-' + nameType + '-';
  for (var i = 0; i < 6; i++) {
    text += validChars.charAt(Math.floor(Math.random() * validChars.length));
  }
  return text;
}

export default {
  randomPracticeName,
  randomEmail,
  randomPracticePhone,
  randomPersonName,
  randNum
};

